import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../lib/motion";

export default function CTASection({
  eyebrow = "Let's build",
  title = "Have an idea? Let's build it.",
  subtitle = "Tell us what you're trying to build, automate, or improve.",
  primary = { label: "Start a Conversation", to: "/contact" },
}) {
  return (
    <section className="relative overflow-hidden bg-[#07111F] py-24 md:py-32 grain" data-testid="cta-section">
      <div className="pointer-events-none absolute -right-24 top-1/2 h-[36rem] w-[36rem] -translate-y-1/2 rounded-full opacity-30 blur-3xl accent-bg" />
      <div className="container-x relative">
        <Reveal>
          <span className="overline accent-text">{eyebrow}</span>
        </Reveal>
        <div className="mt-5 flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-end">
          <Reveal delay={0.05}>
            <h2 className="max-w-2xl font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">
              {title}
            </h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-400">{subtitle}</p>
          </Reveal>
          <Reveal delay={0.12}>
            <Link to={primary.to} className="btn-primary shrink-0" data-testid="cta-button">
              {primary.label} <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
